<script setup>
import { useI18n } from "vue-i18n";
import { FormInput, FormSwitch, FormTextarea } from "@Components/Form";
import { SecondaryButton } from "@Components/Button";
import { ref } from "vue";
import Tooltip from "@Components/Tooltip.vue";
import Badge from "@Components/Badge.vue";
import { PlusIcon, TrashIcon } from "lucide-vue-next";

const props = defineProps(["modelValue"]);
const emit = defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();

const copied = ref(undefined);
const rows = ref(props.modelValue.modules.wordpress.custom_fields);

const variables = [
    {
        name: "LANGUAGE",
        description: "Remplacée par la langue cible de la publication.",
    },
    {
        name: "TITLE",
        description: "Remplacée par le titre de la publication.",
    },
];

const addField = () => {
    rows.value.push({
        key: "",
        is_prompt: false,
        value: "",
    });
};

const removeField = (index) => {
    rows.value.splice(index, 1);
};

const copyVariable = async (variable) => {
    try {
        await navigator.clipboard.writeText("[" + variable.name + "]");
        copied.value = variable.name;
        setTimeout(() => {
            copied.value = undefined;
        }, 2000);
    } catch (err) {}
};
</script>

<template>
    <div class="flex flex-col gap-3">
        <div v-for="(row, i) in rows" class="space-y-3">
            <div class="flex justify-end items-center gap-3">
                <SecondaryButton @click.prevent="removeField(i)" :z="1" :icon="TrashIcon" />
            </div>
            <div class="flex justify-between items-center space-x-3">
                <div class="flex-grow flex items-center space-x-3">
                    <div class="flex-grow">
                        <FormInput v-model="rows[i].key" :placeholder="__('Nom du champ')" dark-mode />
                    </div>
                    <div class="flex-none">
                        <FormSwitch v-model="rows[i].is_prompt" dark-mode>{{ __("Prompt IA") }}</FormSwitch>
                    </div>
                </div>
            </div>
            <div v-if="rows[i].is_prompt">
                <div class="block text-sm font-medium leading-6 text-white">
                    {{ __("Variables disponibles") }}
                </div>

                <div class="mt-2">
                    <div class="-m-1.5 flex flex-wrap">
                        <div v-for="variable in variables" class="p-1.5">
                            <Tooltip :content="__(variable.description)">
                                <Badge @click="copyVariable(variable)" class="relative cursor-pointer">
                                    <span :class="[copied === variable.name ? 'invisible' : '']">[{{ variable.name }}] </span>
                                    <span v-if="copied === variable.name" class="absolute inset-0 inline-flex justify-center items-center">
                                        <span>{{ __("Copié !") }}</span>
                                    </span>
                                </Badge>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            </div>
            <FormTextarea v-model="rows[i].value" :placeholder="rows[i].is_prompt ? __('Prompt') : __('Valeur')" rows="5" dark-mode />
        </div>
        <SecondaryButton @click.prevent="addField" :z="1" class="justify-center">
            <PlusIcon class="w-4 h-4" />
        </SecondaryButton>
    </div>
</template>
